import React from "react";


export default function CargoWeight({item}) {
  const weight = parseInt(item.cargo_weight);
  if (weight && item.container_type && item.container_type.size) {
    let color = '';
    if (
      (item.container_type.size === '20' && weight > 18000) ||
      (item.container_type.size === '40' && weight > 21000)
    ) {
      color = 'red';
    }

    return (
      <span style={{color: color}}>{item.cargo_weight}</span>
    )
  }
  else {
    return (
      <span>{item.cargo_weight}</span>
    )
  }
}
